import { createContext, useEffect, useState } from 'react'
import { Control, useForm } from 'react-hook-form'

import { CheckIcon, PlusIcon, XMarkIcon } from '@heroicons/react/24/outline'

import useServerBusiness from '../../../../api/useServerBusiness'
import Modal from '../../../../components/misc/GenericModal'
import GenericTable, {
  DataTableInterface,
} from '../../../../components/misc/GenericTable'
import { ReservationPolicy } from '../../../../interfaces/ServerInterfaces'
import AddPolicy from './AddPolicy'

interface DiscountContextInterface {
  isFetching?: boolean
  control?: Control
  watch?: (..._args: unknown[]) => unknown
  reset?: () => void
}
export const DiscountContext = createContext<DiscountContextInterface>({})

const DiscountPolicy = () => {
  const {
    getAllReservationPolicy,
    allReservationsPolicy,
    isLoading,
    addNewReservationPolicy,
    isFetching,
    updateReservationPolicy,
    deletedReservationPolicy,
  } = useServerBusiness()

  const { handleSubmit, control, watch, reset, clearErrors } = useForm({
    mode: 'onSubmit',
  })

  // const [openDetailModal, setOpenDetailModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false)
  const [selectPolicy, setSelectPolicy] = useState<ReservationPolicy | null>(
    null
  )

  useEffect(() => {
    if (getAllReservationPolicy) {
      getAllReservationPolicy({ type: 'DISCOUNT' })
    }
  }, [getAllReservationPolicy])

  const titles: string[] = ['Frecuencia', '%', 'Estado', 'Descripción']
  const displayData: DataTableInterface[] = []
  allReservationsPolicy?.forEach((item) => {
    displayData.push({
      rowId: item.id,
      payload: {
        Frecuencia: `${item.quantity} ${translatePolicyFrequencyToSpInTab(
          item.frequency,
          item.quantity
        )}`,
        '%': item.discount,
        Estado: (
          <div className="flex justify-center">
            {item.isActive ? (
              <CheckIcon className="h-7 text-green-500" />
            ) : (
              <XMarkIcon className="w-7 text-red-500" />
            )}{' '}
          </div>
        ),
        Descripción: <p className="text-start">{item.description ?? ''}</p>,
      },
    })
  })

  const rowAction = (id: number) => {
    const select = allReservationsPolicy.find(
      (item: ReservationPolicy) => item.id === id
    )
    setSelectPolicy(select ?? null)
    //setOpenDetailModal(true);
  }

  const actions = [
    {
      icon: <PlusIcon className="flex h-7 justify-center" title="Añadir" />,
      action: () => setOpenAddModal(true),
      title: 'Añadir',
    },
  ]

  const handleDeleted = () => {
    deletedReservationPolicy(selectPolicy?.id as number, () =>
      // setOpenDetailModal(false)
      setSelectPolicy(null)
    )
    clearErrors()
  }

  const onSubmit = (data: Record<string, unknown>) => {
    const { frequency, ...rest } = data
    const adapterData = {
      type: 'DISCOUNT',
      frequency: translatePolicyFrequency(frequency as string),
      ...rest,
    }
    if (addNewReservationPolicy) {
      addNewReservationPolicy(adapterData, () => setOpenAddModal(false))
    }
    clearErrors()
  }

  const onSubmitEdit = (data: Record<string, unknown>) => {
    const { frequency, ...rest } = data
    const adapterData = {
      type: 'DISCOUNT',
      frequency: translatePolicyFrequency(frequency as string),
      ...rest,
    }
    if (updateReservationPolicy) {
      updateReservationPolicy(selectPolicy?.id as number, adapterData, () =>
        // setOpenDetailModal(false)
        setSelectPolicy(null)
      )
    }
  }

  return (
    <>
      <div className="h-full min-h-screen rounded-md bg-white">
        <div>
          <GenericTable
            actions={actions}
            loading={isLoading}
            rowAction={rowAction}
            tableData={displayData}
            tableTitles={titles}
          />
        </div>

        <DiscountContext.Provider value={{ isFetching, control, watch, reset }}>
          {openAddModal && (
            <Modal close={setOpenAddModal} state={openAddModal}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <AddPolicy
                  context={DiscountContext}
                  title=" Añadir nueva"
                  type="discount"
                />
              </form>
            </Modal>
          )}
          {selectPolicy && (
            <Modal close={setSelectPolicy} state={!!selectPolicy}>
              <form onSubmit={handleSubmit(onSubmitEdit)}>
                <AddPolicy
                  action={handleDeleted}
                  context={DiscountContext}
                  defaultValue={selectPolicy}
                  title="Editar "
                  type="discount"
                />
              </form>
            </Modal>
          )}
        </DiscountContext.Provider>
      </div>
    </>
  )
}

export default DiscountPolicy
export const translatePolicyFrequencyToSp = (policy: string) => {
  switch (policy) {
    case 'days':
      return 'Días'
    case 'weeks':
      return 'Semanas'
    case 'months':
      return 'Meses'
    default:
      return ''
  }
}
export const translatePolicyFrequencyToSpInTab = (
  policy: string,
  quantity?: number
) => {
  switch (policy) {
    case 'days':
      return quantity === 1 ? 'Dia' : 'Días'
    case 'weeks':
      return quantity === 1 ? 'Semana' : 'Semanas'
    case 'months':
      return quantity === 1 ? 'Mes' : 'Meses'
    default:
      return ''
  }
}

export const translatePolicyFrequency = (policy: string) => {
  switch (policy) {
    case 'Días':
      return 'days'
    case 'Semanas':
      return 'weeks'
    case 'Meses':
      return 'months'
    default:
      return 'days'
  }
}
